<template>
  <v-row>
    <v-col cols="12" md="6" offset-md="3">
      <form @submit.prevent="save">
        <v-text-field
          v-model="form.pin_code"
          type="password"
          label="Pin *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.pin_code.required)"
        >
          <FormErrorsLine v-if="!$v.form.pin_code.required" text="Polje je obvezno" />
        </FormErrors>
        <v-text-field
          v-model="form.pin_code2"
          type="password"
          label="Ponovno pin *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.pin_code2.required || !$v.form.pin_code2.sameAsPin)"
        >
          <FormErrorsLine v-if="!$v.form.pin_code2.required" text="Polje je obvezno" />
          <FormErrorsLine v-if="!$v.form.pin_code2.sameAsPin" text="Pin kodi se ne ujemata" />
        </FormErrors>
        <v-btn type="submit" class="float-right">Shrani</v-btn>
        <v-btn text type="button" class="float-right mr-4" @click="$router.go(-1)">Prekliči</v-btn>
      </form>
    </v-col>
  </v-row>
</template>

<script>
import { required, sameAs } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'

export default {
  components: {
    FormErrors,
    FormErrorsLine
  },
  data () {
    return {
      form: {
        pin_code: null,
        pin_code2: null
      }
    }
  },
  validations: {
    form: {
      pin_code: {
        required
      },
      pin_code2: {
        required,
        sameAsPin: sameAs('pin_code')
      }
    }
  },
  methods: {
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form })
      }
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>
